import { API_CONFIG, FranchiseData } from '../config/api'

export class FranchiseService {
  private static instance: FranchiseService
  private franchiseData: FranchiseData | null = null

  private constructor() {}

  public static getInstance(): FranchiseService {
    if (!FranchiseService.instance) {
      FranchiseService.instance = new FranchiseService()
    }
    return FranchiseService.instance
  }

  public async getFranchiseData(): Promise<FranchiseData> {
    if (this.franchiseData) {
      return this.franchiseData
    }

    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/franchises/${API_CONFIG.FRANCHISE_ID}`, {
        headers: {
          'x-api-key': API_CONFIG.API_KEY,
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      this.franchiseData = await response.json()
      return this.franchiseData!
    } catch (error) {
      console.error('Error fetching franchise data:', error)
      // Return fallback data if API fails
      return this.getFallbackData()
    }
  }

  private getFallbackData(): FranchiseData {
    return {
      id: 135,
      name: 'Chelsea Travel',
      subdomain: 'chelseatravel',
      topbar_color: '#FFD23F',
      button_color: '#58B8CD',
      main_background_color: '',
      secondary_background_color: '#58B8CD',
      accent_color: '#58B8CD',
      telephone: '021 797 9999',
      emergency_telephone: '0829028416',
      email: 'info@chelseatravel.co.za',
      address: 'Cnr. Wolfe Street & Waterloo Road\r\nWynberg\r\n7800',
      facebook: '',
      instagram: '',
      whatsapp: '',
      catch_phrase: 'People Trust Us, Because They Know We Care',
      cta_text: 'Get The Best Holidays',
      logo_url:
        'https://d181ahmy4p092n.cloudfront.net/franchises/logos/000/000/135/original/CT-HORIZONTAL-LOGO-BLUE.png?1754574462',
      footer_logo_url:
        'https://d181ahmy4p092n.cloudfront.net/franchises/footer_logos/000/000/135/original/CT-VERTICAL-LOGO-BLUE.png?1754574462',
      general_logo_url:
        'https://d181ahmy4p092n.cloudfront.net/franchises/general_logos/000/000/135/original/CT-HORIZONTAL-LOGO-BLUE.png?1754574463',
      background_image_url:
        'https://d181ahmy4p092n.cloudfront.net/franchises/background_images/000/000/135/original/maxresdefault.jpg?1749723491',
    }
  }

  public applyDynamicStyles(franchiseData: FranchiseData): void {
    const root = document.documentElement

    // Apply CSS custom properties for dynamic theming
    root.style.setProperty('--franchise-button-color', franchiseData.button_color)
    root.style.setProperty('--franchise-accent-color', franchiseData.accent_color)
    root.style.setProperty('--franchise-main-bg', franchiseData.main_background_color)
    root.style.setProperty('--franchise-secondary-bg', franchiseData.secondary_background_color)
    root.style.setProperty('--franchise-topbar-color', franchiseData.topbar_color)
  }
}
